/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Exporting_ToastInputs */

const en_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporting QC results...`)
};

const fr_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation des resultats CQ...`)
};

const de_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export der QC-Ergebnisse...`)
};

const it_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione dei risultati del controllo qualità...`)
};

const ru_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт результатов контроля качества...`)
};

const es_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando resultados de control de calidad...`)
};

const zh_cn2_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出质控结果……`)
};

const ja_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QC 結果をエクスポートしています...`)
};

const hi_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गुणवत्ता नियंत्रण परिणामों का निर्यात किया जा रहा है...`)
};

const pt_pt2_style_guide_exporting_toast = /** @type {(inputs: Style_Guide_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando resultados de controle de qualidade...`)
};

/**
* | output |
* | --- |
* | "Exporting QC results..." |
*
* @param {Style_Guide_Exporting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_exporting_toast = /** @type {((inputs?: Style_Guide_Exporting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Exporting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_exporting_toast(inputs)
	if (locale === "de") return de_style_guide_exporting_toast(inputs)
	if (locale === "it") return it_style_guide_exporting_toast(inputs)
	if (locale === "ru") return ru_style_guide_exporting_toast(inputs)
	if (locale === "es") return es_style_guide_exporting_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_exporting_toast(inputs)
	if (locale === "ja") return ja_style_guide_exporting_toast(inputs)
	if (locale === "hi") return hi_style_guide_exporting_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_exporting_toast(inputs)
	return en_style_guide_exporting_toast(inputs)
});